export const root = "rqew14e";
export const imageContainer = "iganccc";
export const image = "i1g8752k";
export const guideTag = "g1jh4wtb";
export const button = "b1vsbj6q";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");